import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import Button from '@material-ui/core/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Link from '@material-ui/core/Link';
import Tab from 'react-bootstrap/Tab';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Modal from 'react-bootstrap/Modal';
import './Application.css';
import Logo from '../assets/hw-logo.png';
import styles from './Application.module.css';
import Agreements from './Agreements';
import AboutYou from './AboutYou';
import YourStory from './YourStory';
import OptionalQuestion from './OptionalQuestion';
import Summary from './Summary';
import Axios from 'axios';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    overflowY: 'auto',
  },
  row: {
    height: '100%',
    alignItems: 'center',
  },
  applicationWrapper: {
    '& > *': {
      width: '100%',
    },
    maxHeight: '970px',
  },
  navBarWrapper: {
    background: theme.palette.secondary.dark,
    borderRadius: '8px 8px 0px 0px',
    padding: '30px 16px',
    display: 'flex',
    flexDirection: 'column',
  },
  navBarTopWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  navLogoTitleWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  exitButton: {
    backgroundColor: '#A43B3B',
    color: '#FFFFFF',
    borderRadius: '4px',
    minWidth: '180px',
    width: '180px',
    height: '50px',
    margin: '0px 5px',
    // Comment below to hide exit button
    display: 'none',
    '&:hover': {
      backgroundColor: '#A43B3B',
    },
  },
  exitButtonText: {
    fontSize: 24,
    fontWeight: '500',
    textTransform: 'none',
    letterSpacing: '-0.04em',
    lineHeight: '31px',
  },
  mobileNavWrapper: {
    overflowX: 'auto',
    scrollbarColor: 'white transparent',
    scrollbarWidth: 'thin',
    // Comment below to hide mobile nav
    display: 'none',
    '&::-webkit-scrollbar': {
      display: 'block',
      height: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#FFFFFF',
      borderRadius: '8px',
      border: '1px',
    },
    '&::::-webkit-scrollbar-track-piece:start': {
      background: 'transparent',
      marginTop: '10px',
    },
    '&::::-webkit-scrollbar-track-piece:end': {
      background: 'transparent',
      marginBottom: '10px',
    },
  },
  mobileNav: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      margin: '15px 0px 15px 10px',
      marginLeft: '10px',
      whiteSpace: 'nowrap',
      width: '800px',
      maxWidth: '800px',
      overflow: 'auto',
      '& > button': {
        width: '140px',
        height: '60px',
        borderRadius: '8px',
        marginRight: '15px',
        textAlign: 'center',
        whiteSpace: 'pre-wrap',
      },
    },
  },
  mobileNavButton: {
    backgroundColor: '#FFFFFF',
    color: '#828282',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: '#FFFFFF',
    },
  },
  mobileNavButtonVistited: {
    backgroundColor: '#394F94 !important',
    color: '#FFFFFF',
  },
  hwLogo: {
    [theme.breakpoints.down('sm')]: {
      width: '46px',
      height: '46px',
    },
    [theme.breakpoints.up('md')]: {
      width: '68px',
      height: '68px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '85px',
      height: '85px',
    },
  },
  navTitle: {
    color: '#FFFFFF',
    fontWeight: 'bold',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 30,
    },
  },
  contentWrapper: {
    background: '#FFFFFF',
    borderRadius: '0px 0px 8px 8px',
    height: '65vh',
    // Comment below to hide main content
    display: 'none',
  },
  innerContentWrapper: {
    width: '100%',
    margin: '0',
    height: '65vh',
  },
  innerContent: {
    maxHeight: '65vh',
    overflowY: 'auto',
    scrollbarColor: 'black transparent',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      display: 'block',
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#000000',
      borderRadius: '8px',
      border: '1px',
    },
    '&::::-webkit-scrollbar-track-piece:start': {
      background: 'transparent',
      marginTop: '10px',
    },
    '&::::-webkit-scrollbar-track-piece:end': {
      background: 'transparent',
      marginBottom: '10px',
    },
  },
  innerContentTab: {
    [theme.breakpoints.down('lg')]: {
      padding: '0 40px',
    },
    [theme.breakpoints.up('lg')]: {
      paddingRight: '20px',
    },
  },
  sideMenu: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  next: {
    width: '100%',
    borderRadius: '4px',
    margin: '0px auto 30px auto',
    textTransform: 'none',
  },
  submitButton: {
    backgroundColor: '#129F23',
    color: '#FFFFFF',
    width: '100%',
    margin: '0px auto 30px auto',
    textTransform: 'none',
    borderRadius: '4px',
  },
  submittedWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  submittedCheck: {
    width: '190px',
    height: '190px',
  },
  submittedTitle: {
    fontSize: 30,
    fontWeight: 'bold',
    letterSpacing: '-0.04em',
    margin: '20px 0px 0px 0px',
  },
  submittedDescription: {
    fontSize: 24,
    textAlign: 'center',
    letterSpacing: '-0.04em',
    marginBottom: '5px',
  },
  socialMediaIconWrapper: {
    '& > a': {
      margin: '0px 10px',
    },
  },
  returnToDashboard: {
    margin: '30px 0px',
    width: '100%',
    borderRadius: '4px',
    textTransform: 'none',
  },
  buttonFonts: {
    fontWeight: 500,
  },
  closedApplicationWrapper: {
    background: '#FFFFFF',
    borderRadius: '0px 0px 8px 8px',
    height: '65vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '& > *': {
      [theme.breakpoints.down('sm')]: {
        fontSize: 18,
      },
      color: theme.palette.primary.main,
    },
  },
}));

const FailedRegistration = ({ openModal, setOpenModal, errorMessage }) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Modal
      show={openModal}
      centered
      size="lg"
      aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          {errorMessage
            ? errorMessage
            : 'Something went wrong. Please try again.'}
          <div>
            If you need assistance, please contact us at{' '}
            <Link href="mailto:hello@hackwestern.com">
              hello@hackwestern.com
            </Link>
            .
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Footer>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setOpenModal(false);
          }}>
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const Application = () => {
  const classes = useStyles();
  const history = useHistory();

  const [activeTab, setActiveTab] = useState('agreements');
  const [agreementsInfo, setAgreementsInfo] = useState({
    MLHCodeOfConduct: false,
    shareApp: false,
    sponsorsShare: false,
  });

  const [aboutYouInfo, setAboutYouInfo] = useState({
    pronouns: '',
    birthday: '',
    school: '',
    schoolYear: '',
    major: [],
    resume: '',
    linkedin: '',
    github: '',
    otherLink: '',
    address: '',
    addressTwo: '',
    province: '',
    city: '',
    postalCode: '',
    swag: null,
    shirtSize: '', // mandatory if swag
    attendedHWBefore: null,
    hackathonsAttendedBefore: '',
  });

  const [yourStoryInfo, setYourStoryInfo] = useState({
    q1coolProject: '',
    q2takeAwayHW: '',
    qbonus: '',
  });

  const [optionalInfo, setOptionalInfo] = useState({
    teammates: [],
    gender: '',
    raceEthnicity: '',
    sexualOrientation: '',
  });

  const [submitted, setSubmitted] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const canMoveOn = agreementsInfo.MLHCodeOfConduct && agreementsInfo.shareApp;

  const canSubmit =
    canMoveOn &&
    aboutYouInfo.pronouns.length > 0 &&
    aboutYouInfo.birthday.length > 0 &&
    aboutYouInfo.school.length > 0 &&
    aboutYouInfo.schoolYear.length > 0 &&
    aboutYouInfo.major.length > 0 &&
    aboutYouInfo.resume.length > 0 &&
    aboutYouInfo.address.length > 0 &&
    aboutYouInfo.city.length > 0 &&
    aboutYouInfo.postalCode.length > 0 &&
    aboutYouInfo.swag !== null &&
    (aboutYouInfo.swag == false || aboutYouInfo.shirtSize.length > 0) &&
    aboutYouInfo.attendedHWBefore !== null &&
    aboutYouInfo.hackathonsAttendedBefore.length > 0 &&
    yourStoryInfo.q1coolProject.length > 0 &&
    yourStoryInfo.q2takeAwayHW.length > 0 &&
    yourStoryInfo.qbonus.length > 0;

  const handlePaneChange = (tab) => {
    if (canMoveOn) {
      setActiveTab(tab);
    }
  };

  useEffect(() => {
    const link =
      process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_DROPLET_URL + '/api/userApplication/saved'
        : 'http://localhost:8080/api/userApplication/saved';
    fetch(link, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    })
      .then((res) => {
        res
          .json()
          .then((body) => {
            if (Object.keys(body).length !== 0) {
              if (body.submitted) {
                throw Error('already submitted');
              }
              setAgreementsInfo({
                MLHCodeOfConduct: true,
                shareApp: true,
                sponsorsShare: body.sponsorsShare,
              });
              setAboutYouInfo({
                ...body.aboutYou,
              });
              setYourStoryInfo({
                ...body.yourStory,
              });
              setOptionalInfo({
                ...body.optional,
              });
              setSubmitted(body?.submitted);
              setActiveTab('aboutYou');
            }
          })
          .catch((err) => {
            history.push('/dashboard');
          });
      })
      .catch((err) => {
        history.push('/dashboard');
      });
  }, []);

  const saveFormInfo = (submit, exit) => {
    const link =
      process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_DROPLET_URL + '/api/userApplication/add'
        : 'http://localhost:8080/api/userApplication/add';
    console.log(aboutYouInfo);
    Axios.post(
      link,
      {
        sponsorsShare: agreementsInfo.sponsorsShare,
        ...aboutYouInfo,
        ...yourStoryInfo,
        ...optionalInfo,
        submitted: submit ? true : false,
      },
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        setSubmitted(submit);
        if (exit) {
          history.push('/dashboard');
        }
      })
      .catch((error) => {
        if (error.response) {
          setErrorMessage('There was an issue saving your application.');
          setOpenModal(true);
        }
      });
  };

  return (
    <Container fluid className={classes.root}>
      <Row className={classes.row}>
        <Col xs={0} sm={0} md={0} lg={1} xl={3} />
        <Col className={classes.applicationWrapper}>
          <div className={classes.navBarWrapper}>
            <div className={classes.navBarTopWrapper}>
              <div className={classes.navLogoTitleWrapper}>
                <img src={Logo} alt="hwLogo" className={classes.hwLogo} />
                <div className={classes.navTitle}>
                  Hack Western 7 Application
                </div>
              </div>
              <Button
                variant="contained"
                className={classes.exitButton}
                onClick={() => {
                  saveFormInfo(false, true);
                }}>
                <Typography variant="h4" className={classes.exitButtonText}>
                  Save and Exit
                </Typography>
              </Button>
            </div>
            <FailedRegistration
              openModal={openModal}
              setOpenModal={setOpenModal}
              errorMessage={errorMessage}
            />
            <div className={classes.mobileNavWrapper}>
              <div className={classes.mobileNav}>
                <Button
                  variant="contained"
                  className={
                    activeTab == 'agreements'
                      ? classes.mobileNavButtonVistited
                      : classes.mobileNavButton
                  }
                  onClick={() => handlePaneChange('agreements')}>
                  <Typography
                    variant="h4"
                    className={classes.mobileNavButtonText}>
                    Agreements
                  </Typography>
                </Button>
                <Button
                  variant="contained"
                  className={
                    activeTab == 'aboutYou'
                      ? classes.mobileNavButtonVistited
                      : classes.mobileNavButton
                  }
                  disabled={!canMoveOn}
                  onClick={() => handlePaneChange('aboutYou')}>
                  <Typography
                    variant="h4"
                    className={classes.mobileNavButtonText}>
                    About You
                  </Typography>
                </Button>
                <Button
                  variant="contained"
                  className={
                    activeTab == 'yourStory'
                      ? classes.mobileNavButtonVistited
                      : classes.mobileNavButton
                  }
                  disabled={!canMoveOn}
                  onClick={() => handlePaneChange('yourStory')}>
                  <Typography
                    variant="h4"
                    className={classes.mobileNavButtonText}>
                    Your Story
                  </Typography>
                </Button>
                <Button
                  variant="contained"
                  className={
                    activeTab == 'optionalQuestion'
                      ? classes.mobileNavButtonVistited
                      : classes.mobileNavButton
                  }
                  disabled={!canMoveOn}
                  onClick={() => handlePaneChange('optionalQuestion')}>
                  <Typography
                    variant="h4"
                    className={classes.mobileNavButtonText}>
                    Optional Questions
                  </Typography>
                </Button>
                <Button
                  variant="contained"
                  className={
                    activeTab == 'summary'
                      ? classes.mobileNavButtonVistited
                      : classes.mobileNavButton
                  }
                  disabled={!canMoveOn}
                  onClick={() => handlePaneChange('summary')}>
                  <Typography
                    variant="h4"
                    className={classes.mobileNavButtonText}>
                    Summary
                  </Typography>
                </Button>
              </div>
            </div>
          </div>
          <div className={classes.contentWrapper}>
            <Tab.Container activeKey={activeTab} fluid>
              <Row className={classes.innerContentWrapper}>
                {!submitted ? (
                  <>
                    <Col lg={4} xl={4} className={classes.sideMenu}>
                      <Nav variant="pills" className={styles.appnav}>
                        <Nav.Item>
                          <Nav.Link
                            className={styles.navLink}
                            eventKey="agreements"
                            onClick={() => handlePaneChange('agreements')}>
                            Agreements
                          </Nav.Link>
                        </Nav.Item>
                        {canMoveOn && (
                          <div>
                            <Nav.Item>
                              <Nav.Link
                                className={styles.navLink}
                                eventKey="aboutYou"
                                onClick={() => handlePaneChange('aboutYou')}>
                                About You
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link
                                className={styles.navLink}
                                eventKey="yourStory"
                                onClick={() => handlePaneChange('yourStory')}>
                                Your Story
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link
                                className={styles.navLink}
                                eventKey="optionalQuestion"
                                onClick={() =>
                                  handlePaneChange('optionalQuestion')
                                }>
                                Optional Questions
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link
                                className={styles.navLink}
                                eventKey="summary"
                                onClick={() => handlePaneChange('summary')}>
                                Summary
                              </Nav.Link>
                            </Nav.Item>
                          </div>
                        )}
                      </Nav>
                    </Col>
                    <Col className={classes.innerContent}>
                      <Tab.Content className={classes.innerContentTab}>
                        <Tab.Pane eventKey="agreements">
                          <Agreements
                            formInfo={agreementsInfo}
                            setFormInfo={setAgreementsInfo}
                          />
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.next}
                            disabled={!canMoveOn}
                            onClick={() => {
                              handlePaneChange('aboutYou');
                            }}>
                            <Typography variant="h4">Continue</Typography>
                          </Button>
                        </Tab.Pane>
                        <Tab.Pane eventKey="aboutYou">
                          <div className={styles.form}>
                            <AboutYou
                              formInfo={aboutYouInfo}
                              setFormInfo={setAboutYouInfo}
                            />
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.next}
                              onClick={() => {
                                saveFormInfo();
                                handlePaneChange('yourStory');
                              }}>
                              <Typography variant="h4">
                                Save and Continue
                              </Typography>
                            </Button>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="yourStory">
                          <div className={styles.form}>
                            <YourStory
                              formInfo={yourStoryInfo}
                              setFormInfo={setYourStoryInfo}
                            />
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.next}
                              onClick={() => {
                                saveFormInfo();
                                handlePaneChange('optionalQuestion');
                              }}>
                              <Typography variant="h4">
                                Save and Continue
                              </Typography>
                            </Button>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="optionalQuestion">
                          <OptionalQuestion
                            formInfo={optionalInfo}
                            setFormInfo={setOptionalInfo}
                          />
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.next}
                            onClick={() => {
                              saveFormInfo();
                              handlePaneChange('summary');
                            }}>
                            <Typography variant="h4">
                              Save and Continue
                            </Typography>
                          </Button>
                        </Tab.Pane>

                        <Tab.Pane eventKey="summary">
                          <Summary
                            state={{
                              aboutYouInfo,
                              yourStoryInfo,
                              optionalInfo,
                            }}
                            canMoveOn={canMoveOn}
                          />
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.submitButton}
                            disabled={!canSubmit}
                            onClick={() => {
                              saveFormInfo(true, true);
                            }}>
                            <Typography variant="h4">Submit</Typography>
                          </Button>
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </>
                ) : (
                  <Col className={classes.submittedWrapper}>
                    <img
                      src={require('../assets/check.png')}
                      alt="submitted"
                      className={classes.submittedCheck}
                    />
                    <div>
                      <p className={classes.submittedTitle}>
                        Thank you for your application
                      </p>
                      <p className={classes.submittedDescription}>
                        Don’t be a stranger!
                      </p>
                      <div className={classes.socialMediaIconWrapper}>
                        <Link
                          href="https://www.instagram.com/hackwestern/"
                          target="_Blank">
                          <img
                            src={require('../assets/_instagram.png')}
                            alt="hwInstagram"
                          />
                        </Link>
                        <Link
                          href="https://www.facebook.com/hackwestern"
                          target="_Blank">
                          <img
                            src={require('../assets/facebook.png')}
                            alt="hwFacebook"
                          />
                        </Link>
                        <Link
                          href="https://www.linkedin.com/company/hack-western/about/"
                          target="_Blank">
                          <img
                            src={require('../assets/linkedin.png')}
                            alt="hwLinkedIn"
                          />
                        </Link>
                        <Link
                          href="https://twitter.com/hackwestern"
                          target="_Blank">
                          <img
                            src={require('../assets/twitter.png')}
                            alt="hwTwitter"
                          />
                        </Link>
                      </div>
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.returnToDashboard}
                        onClick={() => {
                          history.push('/dashboard');
                        }}>
                        <Typography
                          variant="h4"
                          className={classes.buttonFonts}>
                          Applicants Dashboard
                        </Typography>
                      </Button>
                    </div>
                  </Col>
                )}
              </Row>
            </Tab.Container>
          </div>
          <div className={classes.closedApplicationWrapper}>
            <Typography variant="h2">Sorry!</Typography>
            <Typography variant="h2">Application is now closed 😭</Typography>
          </div>
        </Col>
        <Col xs={0} sm={0} md={0} lg={1} xl={3} />
      </Row>
    </Container>
  );
};

export default Application;
